import React from 'react'

import { Spinner } from '@acorns/web-components'
import styled from 'styled-components'

import {
  Body,
  CenteredSpinner,
  ClockIcon,
  IconCircle,
  MessageContainer,
  TextContainer,
  Title,
} from './styled-components'

type Props = {
  title: string
  icon: JSX.Element
  iconAlt: string
  circle?: boolean
  text: string
  hideBottomBorder?: boolean
  children?: React.ReactNode
  additionalText?: React.ReactNode
  isLoading?: boolean
}

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const CardMessage = (props: Props) => (
  <>
    <MessageContainer>
      {props.isLoading ? (
        <CenteredSpinner>
          <Spinner height={40} width={40} />
        </CenteredSpinner>
      ) : (
        <>
          <TextContainer hideBottomBorder={props.hideBottomBorder}>
            {props.circle ? (
              <IconCircle>
                {props.icon}
                <ClockIcon />
              </IconCircle>
            ) : (
              <IconContainer>{props.icon}</IconContainer>
            )}
            <Title>{props.title}</Title>
            <Body>{props.text}</Body>
            {props.additionalText}
          </TextContainer>
          {props.children}
        </>
      )}
    </MessageContainer>
  </>
)

export default CardMessage
